module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_down.914824c8.svg";